import { render, staticRenderFns } from "./parametersAdd.vue?vue&type=template&id=94cdc422&scoped=true&"
import script from "./parametersAdd.vue?vue&type=script&lang=js&"
export * from "./parametersAdd.vue?vue&type=script&lang=js&"
import style0 from "./parametersAdd.vue?vue&type=style&index=0&id=94cdc422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cdc422",
  null
  
)

export default component.exports